import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 获取七牛云token
  getToken(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/file/getToken?${parameterChange(data)}`,
      method: 'get',
    });
  },
};
